import { render, staticRenderFns } from "./ReviewsDisplayItems.vue?vue&type=template&id=ae713efc&"
import script from "./ReviewsDisplayItems.vue?vue&type=script&lang=js&"
export * from "./ReviewsDisplayItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports